import React from 'react';
import { arrayOf, shape, string } from 'prop-types';
import SectionHead from './SectionHead';

/** "So bucht ihr auf Toastably" — the numbered three-step explainer. */
const Steps = props => {
  const { heading, text, items } = props;
  return (
    <section className="section-alt" aria-labelledby="how-title">
      <div className="container">
        <SectionHead id="how-title" heading={heading} text={text} />
        <ol className="steps">
          {items.map((step, i) => (
            <li className="step" key={step.title}>
              <div className="step-num" aria-hidden="true">
                {i + 1}
              </div>
              <h3>{step.title}</h3>
              <p>{step.text}</p>
            </li>
          ))}
        </ol>
      </div>
    </section>
  );
};

Steps.propTypes = {
  heading: string.isRequired,
  text: string,
  items: arrayOf(shape({ title: string, text: string })).isRequired,
};

export default Steps;
